import { ConfigProvider } from 'antd';
import { ConnectedRouter } from 'connected-react-router';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store, { history } from "./Store/configStore";
import axios from './axiosApi';
import './index.css';
import reportWebVitals from './reportWebVitals';


axios.interceptors.request.use(req => {
  try {
    req.params.id = store.getState().applications.data ? store.getState().applications.data['clientId'] : '';
    req.params.hash = store.getState().applications.data ? store.getState().applications.data['hash'] : '';
  } catch (err) {
    console.log(err);
  }
  return req;
});


const app = (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ConfigProvider theme={{ token: { colorPrimary: '#4fc6e0', },cssVar:true }}>
        <App />
      </ConfigProvider>
    </ConnectedRouter>
  </Provider>
)

ReactDOM.render(app,
  document.getElementById('root')
);

reportWebVitals();
